import './TextArea.scss';

const TextArea = ({ placeholder, ...etc }) => (
  <textarea placeholder={placeholder || ''} {...etc} />
);

export default TextArea;
